<style scoped lang="scss">
    @import "../../styles/var";

    .cover {
        border: 1px solid $mainColor;
    }

    .cover + li {
        border-top: 1px solid $mainColor;
    }

    li + li {
        margin-top: -1px;
    }
</style>
<template>
    <div class="list">
        <div class="mb10">
            <el-input placeholder="请输入内容" prefix-icon="el-icon-search"></el-input>
        </div>
        <el-collapse accordion v-model="active" v-for="(obj,index) in 2" :key="index">
            <el-collapse-item :name="index">
                <template slot="title">
                    <div class="fs14 pl15">待处理(23)</div>
                </template>
                <ul>
                    <li class="pl15 pr15 pt15 pb15 bt bb" v-for="(o,i) in 3">
                        <div class="flex color_333 fs14">
                            <span class="flex0">李俊基</span>
                            <span class="flex0 ml5">男</span>
                            <span class="flex1 ml5">23岁</span>
                            <span class="flex0 color_orange">￥50</span>
                        </div>
                        <div class="fs12 color_666 lines2">
                            医生医生，我有个问题想咨询你一下，医生医生，我有个问题想咨询你一下，医生医生，我有个问题想咨询你一下，医生医生，我有个问题想咨询你一下，
                        </div>
                        <div class="flex mt5 aic">
                            <span class="flex1 fs12 color_999">1小时前创建</span>
                            <span class="flex0 fs15 color_main">待处理</span>
                        </div>
                    </li>
                </ul>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>

  export default {
    name: "consult-list",
    components: {},
    props: {
      list: Array,
    },
    data() {
      return {
        height: 0,
        active: 0
      }
    },
    computed: {},
    created() {
    },
    methods: {}
  }
</script>
